const dimensions = {
  headerHeight:  55,
  footerHeight: 55,
  maxWidth: 1024,
  maxWidthXL: 1400,
};

export default dimensions;
